import React, { useEffect } from 'react'
import { StyledExam } from './Styled'
import Header from './Header'
import InformationForm from './InformationForm'
import Confirmation from './Confirmation'
import ActionBar from './ActionBar'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { fetchInitials } from './events'
import { useHistory, useParams } from 'react-router-dom'
import _ from 'lodash'
import { initSocketListener } from 'src/utils/lib'
import { handleSocketResponse } from '../events'
import { handleErrorSocket } from './InformationForm/event'
import { setSocketId } from 'src/redux/slices/class/enroll'

const Enroll = () => {
  const history = useHistory()
  const callbackUrl = useSelector((state) => state.document.callbackUrl)
  const params = useParams()
  const classUuid = _.get(params, 'id', '')
  const dispatch = useDispatch()

  const { enroll, progress, isInitialLoaded } = useSelector(
    (state) => ({
      enroll: state.classEnroll.enroll,
      progress: state.classEnroll.progress,
      isInitialLoaded: state.classEnroll.isInitialLoaded,
    }),
    shallowEqual,
  )

  useEffect(() => {
    dispatch(fetchInitials())
  }, [])

  useEffect(() => {
    if (isInitialLoaded && progress === 0) {
      history.goBack()
    }
  }, [isInitialLoaded, progress])

  useEffect(() => {
    const socket = initSocketListener({
      onMessage: (res, dispatch) =>
        dispatch(handleSocketResponse(res, classUuid)),
      onError: (res, dispatch) =>
        dispatch(handleErrorSocket(res.content, callbackUrl)),
      dispatch,
      onConnect: (id) => dispatch(setSocketId(id)),
    })

    return () => {
      socket.disconnect()
    }
  }, [classUuid])

  // ✅ เช็ก enroll ให้แน่ใจว่ามีข้อมูลก่อน render
  if (!isInitialLoaded || !Array.isArray(enroll) || enroll.length === 0) {
    return <div>⏳ กำลังโหลดข้อมูลสมัคร...</div>
  }

  return (
    <>
      <StyledExam>
        <Header />
        {progress === 1 && <InformationForm />}
        {progress === 2 && <Confirmation />}
      </StyledExam>
      <ActionBar />
    </>
  )
}

export default Enroll
